import {ErrorMessages} from 'constants/Errors';

import {AxiosResponse} from 'axios';
import {call, put} from 'redux-saga/effects';
import {getSingleBeerData} from 'services/beers';
import {handleError} from 'store/app/error/saga';
import {setBeersIncludedAC} from 'store/beers/beerSlice';
import ApiData from 'typescript/interfaces/ApiData';
import {Beer} from 'typescript/models/Beer';

import {setSingleBeerAC} from '../beerPreviewSlice';
import {getSingleBeerACS} from '../requests';

export function* getSingleBeerSaga(action: ReturnType<typeof getSingleBeerACS>) {
  try {
    const response: AxiosResponse<ApiData<Beer>> = yield call(getSingleBeerData, action.payload);
    const {data} = response;

    yield put(setSingleBeerAC(data.data));
    yield put(setBeersIncludedAC(data.included));
  } catch (error) {
    yield call(handleError, error, ErrorMessages.DATA);
  }
}
